import { Table, TableHead, TableBody, TableRow, TableCell, Typography } from "@material-ui/core";
import { CircleLoader, PageContent } from "components"
import { useContext } from "react";
import { qrCodeInfoContext } from "../QrCodeCheckContext";

let Results = () => {
    let service = useContext(qrCodeInfoContext);

    return (
        <PageContent>
            {service.isSearching && <CircleLoader />}
            {service.isSearching === false && service.isSearchDone &&
                <>
                    {!service.qrCodeInfo &&
                        <Typography variant="subtitle2" style={{ marginTop: 24, marginLeft: 16 }}>Qr Code not found or invalid</Typography>
                    }
                    {service.qrCodeInfo &&
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>SKU</TableCell>
                                    <TableCell>Country</TableCell>
                                    <TableCell>Customer Code</TableCell>
                                    <TableCell>Customer</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{service.qrCodeInfo.sku}</TableCell>
                                    <TableCell>{service.qrCodeInfo.country}</TableCell>
                                    <TableCell>{service.qrCodeInfo.customerCode}</TableCell>
                                    <TableCell>{service.qrCodeInfo.customerDescription}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    }
                </>
            }
        </PageContent>
    )
}

export default Results;